import { render, staticRenderFns } from "./SgaProductPicker.vue?vue&type=template&id=6e7d8f8a"
import script from "./SgaProductPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./SgaProductPicker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports